<div class="card">
    <div class="card-header">
        <h4 class="card-title mb-0">Filtros disponibles</h4>
    </div>
    <div class="card-body">
        <div class="card-block">
            <form novalidate [formGroup]="filtersForm" (ngSubmit)="onSubmit()">
                <div class="row">
                    <ng-container *ngFor="let filter of filters">
                        <div class="col-md-4 display-inline-block" *ngIf="filter.type === 'select'">
                            <app-select [form]="filtersForm" [filter]="filter"
                                (changeItem)="changeItem($event)"></app-select>
                        </div>
                        <div class="col-md-4 display-inline-block" *ngIf="filter.type === 'select-search-simple'">
                            <app-select-search-simple [form]="filtersForm" [filter]="filter"
                                (changeItem)="changeItem($event)"></app-select-search-simple>
                        </div>
                        <div class="col-md-4 display-inline-block" *ngIf="filter.type === 'input-date'">
                            <app-input-date [form]="filtersForm" [filter]="filter"></app-input-date>
                        </div>
                        <div class="col-md-4 display-inline-block" *ngIf="filter.type === 'input-date-range'">
                            <app-input-date-range [form]="filtersForm" [filter]="filter"
                                (range)="sendRange($event)"></app-input-date-range>
                        </div>
                        <div class="col-md-4 display-inline-block" *ngIf="filter.type === 'input'">
                            <app-input [form]="filtersForm" [filter]="filter"></app-input>
                        </div>
                    </ng-container>
                </div>
                <div class="row">
                    <div class="col d-block d-sm-flex justify-content-end">
                        <button type="submit" class="col-6 col-sm-3 btn btn-raised btn-primary mr-2">
                            <span class="ft-search"></span> Buscar</button>
                        <button type="button" class="col-6 col-sm-3 btn btn-raised btn-secondary"
                            (click)="resetFilters()">
                            <span class="ft-trash"></span> Reiniciar Búsqueda </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>